import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import App from "./App";
import Rundown from "./components/Rundown";
import Output from "./components/shared/Output";
import Theme from "./components/shared/Theme";
import Social from "./components/shared/Social";
import Media from "./components/shared/Media";
import Score from "./components/shared/Score";
import Variables from "./components/shared/Variables";
import Licence from "./components/Licence";
import Buttons from "./components/shared/Buttons";
import Control from "./components/shared/Control";
import ThemePreview from "./components/shared/theme/ThemePreview";
import QandA from "./components/shared/QandA";
import Build from "./components/shared/Build";

export default function AppRouter() {
	return (
		<Router>
			<Switch>
				<Route path="/licence">
					<Licence />
				</Route>
				<Route path="/build/:projectId">
					<Build />
				</Route>
				<Route path="/qanda/:projectId">
					<QandA />
				</Route>
				<Route path="/variables/:projectId">
					<Variables />
				</Route>
				<Route path="/score/:projectId">
					<Score />
				</Route>
				<Route path="/media/:projectId">
					<Media />
				</Route>
				<Route path="/social-only/:projectId">
					<Social navbar={false} />
				</Route>
				<Route path="/social/:projectId">
					<Social />
				</Route>
				<Route path="/theme/:projectId/:themeId/preview">
					<ThemePreview />
				</Route>
				<Route path="/theme/:projectId/:themeId">
					<Theme />
				</Route>
				<Route path="/buttons/:projectId">
					<Buttons />
				</Route>
				<Route path="/control/:projectId">
					<Control />
				</Route>
				<Route path="/rundown/:projectId">
					<Rundown />
				</Route>
				<Route exact path="/preview/:projectId">
					<Output />
				</Route>
				<Route exact path="/preview/:outputId">
					<Output />
				</Route>
				<Route exact path="/output/:projectId">
					<Output />
				</Route>
				<Route path="/output/:projectId/:outputId">
					<Output />
				</Route>
				<Route path="/">
					<App />
				</Route>
			</Switch>
		</Router>
	);
}
